import React from "react";
import { Col, Row, Table, Card, Select, Form, Skeleton, Modal } from "antd";
import moment from "moment";

const { Option } = Select;
const { confirm } = Modal;

const columns = [
  {
    title: "Invitation Sent",
    dataIndex: "invitaionSent",
    key: "invitaionSent",
    render: (_, record) => (
      <span>
        {record.invitaionSent
          ? moment(record.invitaionSent).local().format("YYYY-MM-DD HH:mm:ss")
          : ""}
      </span>
    ),
    sorter: (a, b) =>
      a.invitaionSent ? a.invitaionSent.localeCompare(b.invitaionSent) : null,
  },
  {
    title: "Invitation Expires",
    dataIndex: "invitaionExpires",
    key: "invitaionExpires",
    render: (_, record) => (
      <span>
        {record.invitaionSent
          ? moment(record.invitaionExpires)
              .local()
              .format("YYYY-MM-DD HH:mm:ss")
          : ""}
      </span>
    ),
    sorter: (a, b) =>
      a.invitaionExpires
        ? a.invitaionExpires.localeCompare(b.invitaionExpires)
        : null,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: (a, b) => (a.status ? a.status.localeCompare(b.status) : null),
  },
];

const ActivationDetails = (props) => {
  const {
    tableData,
    cardTitleStyle,
    userDetails,
    userStatus,
    isLoading,
    userSignerStatus,
    updateStatus,
    removeSigners,
    userId
  } = props;

  const getDeactivateMessage = () => {
    let message = "";
    const singleUsersString = `'${userSignerStatus.singleUsers.join("', '")}'`;
    const multipleUsersString = `'${userSignerStatus.multipleUsers.join(
      "', '",
    )}'`;
    if (
      userSignerStatus.singleUsers?.length &&
      userSignerStatus.multipleUsers?.length
    )
      message = `This user is the signer of the following hotel(s): ${multipleUsersString} and only signer for the following hotel(s): ${singleUsersString} please replace the signer before deactivating the user.`;
    else if (
      userSignerStatus.singleUsers?.length &&
      !userSignerStatus.multipleUsers?.length
    ) {
      message = `This user is the only signer for the following hotel(s): ${singleUsersString} and must be replaced before deactivating.`;
    } else if (
      !userSignerStatus.singleUsers?.length &&
      userSignerStatus.multipleUsers?.length
    ) {
      message = `Deactivating this user account will remove them from the signer list for the following hotel(s): ${multipleUsersString}`;
    } else message = "Do you want to deactivate the user?";
    return message;
  };

  const showModal = (status) => {
    const statusText = status
      ? "Do you want to activate the user?"
      : getDeactivateMessage();

    confirm({
      title: statusText,
      icon: null,
      width: status ? 400 : 550,
      okText: userSignerStatus?.multipleSignerOnly ? "Deactivate" : "Ok",
      onOk() {
        if (status) updateStatus({ data: { status }, id: userId });
        else if (!status && userSignerStatus.canAdminDeactivateUser) {
          removeSigners({ id: userId });
          updateStatus({ data: { status: false }, id: userId });
        }
      },
    });
  };

  return process.env.REACT_APP_PLATFORM_TYPE === "GENERIC" ? (
    <Card
      title={<span style={cardTitleStyle}>Account Activation</span>}
      bordered={false}
      extra={
        <Form>
          <Form.Item>
            <Select
              style={{ width: 120 }}
              onChange={showModal}
              disabled={userDetails && userStatus == "Pending"}
              value={!!userDetails?.status}
              loading={isLoading}
            >
              <Option value>Activate</Option>
              <Option value={false}>Deactivate</Option>
            </Select>
          </Form.Item>
        </Form>
      }
    >
      <Row>
        <Col xs={24} sm={24} md={18} lg={20} xl={20}>
          {isLoading ? (
            <Skeleton active title={false} paragraph={{ rows: 4 }} />
          ) : (
            <Table
              dataSource={tableData}
              columns={columns}
              pagination={false}
              className="sm-custom-column-header"
            />
          )}
        </Col>
      </Row>
    </Card>
  ) : null;
};

ActivationDetails.propTypes = {};

export default ActivationDetails;
